import { useState } from "react";
import { approveCortevaInvoice } from "../utils/cortevaInvoiceRegistry";
import { runWithCorrectionPrompt } from "../services/financeCore/invoiceCorrection";
import TaxTreatmentPanel from "./TaxTreatmentPanel";

// Mirrors cortevaInvoiceRegistry.js's clientCodeForSegment() — kept in sync
// manually since this is a display-only lookup (TaxTreatmentPanel preview),
// not the source of truth for what actually gets written on approval.
function clientCodeForSegment(segmentKey) {
  return segmentKey === "ifs" || segmentKey === "consultantCrop" ? "CORTEVA_CROP" : "CORTEVA";
}

export default function CortevaApprovalControls({ invoice }) {
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  async function approve() {
    setSaving(true);
    setMessage("");
    try {
      const saved = await runWithCorrectionPrompt((options) => approveCortevaInvoice(invoice, options));
      setMessage(saved.unchanged
        ? `${saved.invoiceNumber} is already approved with exactly these figures — nothing to change.`
        : saved.corrected
          ? `${saved.invoiceNumber} corrected. The ${saved.monthKey} receivable, P&L and Corteva reconciliation now use the new figures.`
          : `${saved.invoiceNumber} approved and added to ${saved.monthKey} Corteva reconciliation.`);
    } catch (error) {
      setMessage(error.message || "Invoice approval failed.");
    } finally {
      setSaving(false);
    }
  }

  return <div style={{ marginTop: 12 }}>
    {invoice?.grossAmount > 0 && (
      <TaxTreatmentPanel clientCode={clientCodeForSegment(invoice.segmentKey)} normalized={{
        serviceChargeSubtotal: invoice.serviceCharges,
        gstAmount: invoice.gstAmount,
        grossAmount: invoice.grossAmount,
        recoveryBase: null
      }} />
    )}
    <button className="btn btn-success" type="button" disabled={saving || !invoice?.grossAmount} onClick={approve}>{saving ? "Saving approval…" : "Approve & Save Invoice"}</button>
    {message && <p className="page-copy" role="status" style={{ marginTop: 10 }}>{message}</p>}
  </div>;
}
